import  { NavigationTabs as SourceNavigationTabs }  from 'SourceComponent/NavigationTabs/NavigationTabs.component';
import media, { WYSIWYG_MEDIA } from "Util/Media/Media";
import PropTypes from "prop-types";
import { DeviceType } from 'Type/Device';
import {lazy} from "react";

export const UniversalIcon = lazy(() => import(
    /* webpackMode: "lazy", webpackChunkName: "icons" */
    'Component/UniversalIcon'
    ));

/** @namespace Component/NavigationTabs/Component */
export class NavigationTabs extends SourceNavigationTabs {
    static propTypes = {
        device: DeviceType.isRequired,
        isCheckout: PropTypes.bool.isRequired
    };

    static defaultProps = {
        header_bg: '#ffffff',
        header_fc: '#000000',
        header_inverse_icons: false
    };

    shouldComponentUpdate(nextProps) {
        const {
            navigationState: { name: prevName },
            headerState: { prevHeaderName },
            cartTotals: { items_qty: prevQty },
            device: prevDevice
        } = this.props;

        const {
            navigationState: { name: nextName },
            headerState: { name: headerName },
            cartTotals: { items_qty: nextQty },
            device: nextDevice
        } = nextProps;

        return prevName !== nextName || 
               nextQty !== prevQty || 
               prevDevice !== nextDevice || 
               prevHeaderName !== headerName;
    }


    renderMenuButton(isActive = false) {
        const { onMenuButtonClick, headerState: { name = ''}, header_inverse_icons } = this.props;

        // const isHidden = name == 'pdp';
        
        return (
            <button
                key="menu"
                block="NavigationTabs"
                elem="Button"
                aria-label="Go to menu and search"
                onClick={ onMenuButtonClick }
                // mods={ { isHidden } }
            >
                <UniversalIcon
                    src={media(header_inverse_icons ? 'menu_white.svg' : 'menu.svg', WYSIWYG_MEDIA)}
                    alt="MenuIcon"
                    className="MenuIcon"
                />
            </button>
        );
    }

    renderAccountButton(isActive = false) {
        const { onMyAccountButtonClick, header_inverse_icons } = this.props;

        return (
            <button
                rel='nofollow'
                key="account"
                block="NavigationTabs"
                elem="Button"
                onClick={ onMyAccountButtonClick }
                aria-label="Open my account"
                className="NavigationTabs-account"
            >
                <UniversalIcon
                    src={media(header_inverse_icons ? 'account_white.svg' : 'account.svg', WYSIWYG_MEDIA)}
                    alt="UserIcon"
                    className="UserIcon"
                />
            </button>
        );
    }

    renderMinicartButton(isActive = false) {
        const { onMinicartButtonClick, header_inverse_icons } = this.props;

        return (
            <button
                key="mincart"
                block="NavigationTabs"
                elem="Button"
                onClick={ onMinicartButtonClick }
                aria-label="Minicart"
            >
                <div block="Header" elem="MinicartWrapper">
                    <div
                        block="Header"
                        elem="Button"
                        mix={ { block: 'NavigationTabs', elem: 'Icon', mods: { isActive } } }
                        mods={ { isVisible: true, type: 'minicart' } }
                    >
                        <UniversalIcon
                            src={media(header_inverse_icons ? 'cart_white.svg' : 'cart.svg', WYSIWYG_MEDIA)}
                            alt="CartIcon"
                            className="CartIcon"
                        />
                    </div>
                    { this.renderMinicartItemsQty() }
                </div>
            </button>
        );
    }

    render() {
        const { navigationState: { isHidden = false } = {}, isCheckout, device, header_bg, header_fc } = this.props;

        if (!device.isMobile || isCheckout) {
            return null;
        }

        const style = {
            '--header-bg': header_bg,
            '--header-fc': header_fc
        };

        return (
            <footer
              block="NavigationTabs"
              mods={ { isHidden } }
              mix={ { block: 'FixedElement', elem: 'Bottom' } }
              id="NavigationTabs"
              style={ style }
            >
                <nav block="NavigationTabs" elem="Nav">
                    { this.renderNavigationState() }
                </nav>
            </footer>
        );
    }
}

export default NavigationTabs;
